import React, { FC } from 'react';

import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { dayPluralize, monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { ICostRa } from '~/src/api/content/shop/getShopItems';
import { IYandexTrial } from '~/src/components/Promo/popups/PartnerPopup/types';
import YandexTrial from '~/src/components/Promo/YandexTrial';

import * as ST from './styled';

interface IProps {
    isTrial: boolean,
    trials: IYandexTrial[],
    price?: number,
    costRa: ICostRa[],
    setSelectedTrial: (trial: IYandexTrial) => void,
    selectedFlagRa?: number,
}

const YandexPrice: FC<IProps> = ({ isTrial, trials, price, setSelectedTrial, selectedFlagRa, costRa }) => {
    if (trials.length) {
        return (
            <ST.YandexTrialsBlock>
                {trials.map(trial => (
                    <YandexTrial
                        isActive={trial.flagRa === selectedFlagRa}
                        onClick={() => setSelectedTrial(trial)}
                        key={trial.flagRa}
                        months={trial.duration}
                        desc={trial.description}
                        price={trial.price}
                        fullPrice={price}
                    />
                ))}
            </ST.YandexTrialsBlock>
        );
    }

    if (!isTrial) {
        return (
            <ST.YandexPrice>
                Стоимость подписки — {price} ₽/мес.
            </ST.YandexPrice>
        );
    }

    const duration = costRa[0].duration;
    const cost = costRa[0].cost;
    const durTypeId = costRa[0].dur_type_id;
    const durType = durTypeId === 1 ? getPluralize(monthPluralize) : getPluralize(dayPluralize);
    const textPrice = !cost ? 'бесплатно' : `${cost} ₽/${durTypeId === 1 ? 'мес' : 'день'}`;

    return (
        <ST.YandexPrice>
            {duration === 1 ? 'Первый месяц' : `Первые ${duration} ${durType(duration)}`} {textPrice}, а потом — {price} ₽/мес.
        </ST.YandexPrice>
    );
};

export default YandexPrice;
